import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const PartnersComponent = lazy(() => import('./partners.tsx'));

export const partnersRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <PartnersComponent />
      </Suspense>
    )
  }
];
